import { createAction, props } from '@ngrx/store';
import { CmsPageContentType, DocumentType } from '@rd/types';

export const CmsGetRefKeySuccess = createAction(
  '[Cms] Get Ref Key Success',
  props<{ ref: string | null }>(),
);
export const CmsGetRefKeyFailed = createAction(
  '[Cms] Get Ref Key Failed',
  props<{ error: Error | null }>(),
);
export const CmsLoadPageContent = createAction(
  '[Cms] Load Page Content',
  props<{ pageType: DocumentType; pageName: string; locale: string }>(),
);
export const CmsLoadPageContentSuccess = createAction(
  '[Cms] Load Page Content Success',
  props<{
    pageName: string;
    data: CmsPageContentType;
  }>(),
);
export const CmsLoadPageContentFailed = createAction(
  '[Cms] Load Page Content Failed',
  props<{ pageName: string; error: Error }>(),
);
